export default __webpack_public_path__ + "static/media/misc-books3-1920w.67166c6f.webp";